import { render } from "./App.vue?vue&type=template&id=13ac3d5d"
const script = {}

import exportComponent from "../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.20_vue@3.5.20_typescript@5.0.4__webpack@5.101.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__